// 아래 바 위에 붙는 패널과 큰 시트: Go to 장소 버튼, 8글자 키보드, 방 메뉴(료칸·바·매점), Leaf 상점.
import { CHAT_LETTERS } from '@capy/shared';
import { LINE } from './lineIcons';
import { el, iconBtn } from './shell';
import { setLabel } from './icons';
import { HUD_TEXT as TX } from '../text/en';

export interface Choice { label: string; click(): void; on?: boolean }

/** Go to: 장소 버튼만 3열로 (배경·설명 없이). */
export function placesPanel(list: Choice[]): HTMLElement {
  const g = el('div', 'places');
  for (const p of list) {
    const b = el('button', 'pbtn' + (p.on ? ' sel' : ' glass'));
    b.type = 'button'; b.textContent = p.label;
    b.addEventListener('click', p.click);
    g.append(b);
  }
  return g;
}

export interface Talk { el: HTMLElement; type(k: string): void }
/** 8글자 키보드: 입력칸 + 보내기, 글자 8개 한 줄, 띄어쓰기·지우기. */
export function talkPanel(onSend: (msg: string) => void, max: number): Talk {
  const box = el('div', 'panel glass talk');
  const row = el('div', 'draftrow');
  const draftEl = el('div', 'draft empty', TX.chatHint);
  const send = iconBtn('send', LINE.send, undefined, 'Say it');
  row.append(draftEl, send);
  const kb = el('div', 'kb');
  let draft = '';
  const render = () => {
    draftEl.textContent = draft || TX.chatHint;
    draftEl.classList.toggle('empty', !draft);
    send.classList.toggle('ready', !!draft.trim());
  };
  const type = (k: string) => {
    if (k === 'back') draft = draft.slice(0, -1);
    else if (k === 'send') { const m = draft.trim(); if (m) { onSend(m); draft = ''; } }
    else if (draft.length < max) draft += k === 'space' ? (draft && !draft.endsWith(' ') ? ' ' : '') : k;
    render();
  };
  for (const ch of CHAT_LETTERS) { const b = el('button', 'k', ch); b.type = 'button'; b.addEventListener('click', () => type(ch)); kb.append(b); }
  const sp = el('button', 'k space', TX.space); sp.type = 'button'; sp.addEventListener('click', () => type('space'));
  const bs = iconBtn('k back', LINE.backspace, undefined, 'Delete'); bs.addEventListener('click', () => type('back'));
  kb.append(sp, bs);
  send.addEventListener('click', () => type('send'));
  box.append(row, kb);
  render();
  return { el: box, type };
}

export interface MenuItemView { icon: string; label: string; sub?: string; on?: boolean; click(): void }
/** 방 메뉴: 제목 줄(오른쪽에 주문 버튼·닫기) + 가로로 넘기는 한 줄. */
export function menuPanel(title: string, items: MenuItemView[], onClose: () => void, action?: { label: string; click(): void }): HTMLElement {
  const box = el('div', 'panel glass menu');
  const head = el('div', 'phead');
  head.append(el('h3', '', title));
  const right = el('div', 'pright');
  if (action) { const a = el('button', 'btn dark'); a.type = 'button'; setLabel(a, action.label); a.addEventListener('click', action.click); right.append(a); }
  const x = iconBtn('x', LINE.close, undefined, 'Close'); x.addEventListener('click', onClose);
  right.append(x); head.append(right);
  const strip = el('div', 'mstrip');
  for (const it of items) {
    const b = el('button', 'mit' + (it.on ? ' sel' : ''));
    b.type = 'button';
    const ic = el('span', 'mic'); setLabel(ic, it.icon);
    b.append(ic, el('span', 'ml', it.label));
    if (it.sub) b.append(el('small', '', it.sub));
    b.addEventListener('click', it.click);
    strip.append(b);
  }
  box.append(head, strip);
  return box;
}

/** Leaf 상점 (구매는 결제 단계 전까지 막아 둔다). */
export function storeSheet(need: string, onClose: () => void, onBuy: () => void): HTMLElement {
  const box = el('div', 'sheet glass store');
  box.append(el('div', 'grab'));
  const head = el('div', 'phead');
  head.append(el('h3', '', TX.store.title));
  const x = iconBtn('x', LINE.close, undefined, 'Close'); x.addEventListener('click', onClose);
  head.append(x);
  box.append(head, el('p', 'need', need));
  const g = el('div', 'packs');
  for (const [n, l, price] of TX.store.packs) {
    const p = el('div', 'pack');
    p.append(el('b', '', `🍃 ${n}`), el('span', '', l));
    // 결제 단계 전까지는 눌러도 "곧 열린다" 알림만
    const b = el('button', 'btn dark', price); b.type = 'button'; b.addEventListener('click', onBuy);
    p.append(b); g.append(p);
  }
  box.append(g, el('p', 'note', TX.store.note));
  return box;
}
